export default __webpack_public_path__ + "static/media/logo.7699a0cb.png";